import {
  centeredUrlRequestContainer,
  darkLoadingContainer,
  homepageBrandingBanner,
  homepageBrandingBannerContainer,
  homepageCornerPlusIcon,
  paginationContainer,
  playlistsContainer,
} from "./my_playlists_styles";
import BrandingBanner from "../components/BrandingBanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  InlineAddPlaylist,
  InvitationToConnectPlaylist,
  MyPlaylists,
  PlaylistsList,
} from "./MyPlaylists";
import { DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL, getMyPlaylists } from "@sharpana/auth/api_client/summarization_api";
import { useEffect } from "react";
import { Pagination, Spin, message } from "antd";
import { useState } from "react";
import { Playlist } from "./types/activity_types";
import { SummarizationURLRequest } from "./SummarizationURLRequest";
import { PlaylistDetail as PlaylistDetailType } from "@sharpana/auth/api_client/summarization_api";
import { PlaylistDetailInner } from "./PlaylistDetail";

export const HomeFeed = () => {
  const navigate = useNavigate();

  const [playlists, setPlaylists] = useState<Playlist[]>([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSinglePlaylistDetail, setCurrentPageSinglePlaylistDetail] = useState(1);
  const [totalPlaylists, setTotalPlaylists] = useState(0);
  const [singlePlaylist, setSinglePlaylist] =
    useState<PlaylistDetailType | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
  const playlistsPageSize = 15;
  const singlePlaylistDetailPageSize = DEFAULT_PAGE_SIZE_PLAYLIST_DETAIL;

  const fetchData = async (page: number) => {
    try {
      setLoading(true);
      const [playlistsResponse] = await Promise.all([
        getMyPlaylists(page, playlistsPageSize, true, singlePlaylistDetailPageSize) as Promise<PlaylistsResponse>,
      ]);

      if (playlistsResponse.error) {
        throw new Error(playlistsResponse.error);
      }

      setPlaylists(playlistsResponse.results || []);
      setTotalPlaylists(playlistsResponse.total || 0);
      setSinglePlaylist(playlistsResponse.single_playlist_details || null);
      setCurrentPage(playlistsResponse.current_page || page);
    } catch (error) {
      console.error("Failed to fetch data:", error);
      message.error("Failed to load content. Please try again later.");
      setPlaylists([]);
      setTotalPlaylists(0);
      setSinglePlaylist(null);
      setError(
        error
          ? String(error)
          : "Failed to load content. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, refreshTrigger]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return (
      <div css={darkLoadingContainer}>
        <Spin size="large" />
      </div>
    );
  }
  const refreshPlaylists = () => {
    // Increment the refresh trigger to cause a re-fetch
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div css={playlistsContainer}>
      <div css={homepageBrandingBannerContainer}>
        <BrandingBanner css={homepageBrandingBanner} />

        {playlists.length !== 0 && (
          <div
            onClick={() => navigate("/summarization-request")}
            css={homepageCornerPlusIcon}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" color="white" />
          </div>
        )}
      </div>

      {playlists.length === 0 ? (
        <div css={centeredUrlRequestContainer("55vh")}>
          <SummarizationURLRequest />
        </div>
      ) : (
        <></>
      )}

      {/* Playlists or invitation to add playlist */}
      {playlists.length === 0 && !loading ? (
        <InvitationToConnectPlaylist refreshPlaylists={refreshPlaylists} />
      ) : (
        <>
          {playlists.length === 1 ? (
            <>
              {singlePlaylist && (
                <PlaylistDetailInner
                  id={singlePlaylist.id}
                  playlist={singlePlaylist}
                  setPlaylist={setSinglePlaylist}
                  loading={loading}
                  setLoading={setLoading}
                  error={error}
                  setError={setError}
                  autoRefreshOnStart={true}
                  showBackButton={false}
                  pageSize={singlePlaylistDetailPageSize}
                  currentPage={currentPageSinglePlaylistDetail}
                  setCurrentPage={setCurrentPageSinglePlaylistDetail}
                />
              )}
            </>
          ) : (
            <>
              {/* Playlist items and their corresponding pagination */}
              <PlaylistsList playlists={playlists} />
              {totalPlaylists > playlistsPageSize && (
                <>
                  <div css={paginationContainer}>
                    <Pagination
                      current={currentPage}
                      total={totalPlaylists}
                      pageSize={playlistsPageSize}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                    />
                  </div>
                </>
              )}
            </>
          )}

          {/* Add Playlist Button - inline */}
          <InlineAddPlaylist refreshPlaylists={refreshPlaylists} />
        </>
      )}
    </div>
  );
};
